import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useParams, useSearchParams } from 'next/navigation';
import {
  getCustomerRatingsAndReviewsPageUrl,
  type GetCustomerRatingsAndReviewPageUrlProps,
} from '../../helper/getCustomerRatingsAndReviewsPageUrl/getCustomerRatingsAndReviewsPageUrl';

export type GetUrlProps = Pick<GetCustomerRatingsAndReviewPageUrlProps, 'variationId' | 'page'>;

export const useCustomerRatingsAndReviewPage = () => {
  const params = useParams();
  const searchParams = useSearchParams();
  const { language, localizeUrl } = useI18n();

  const getUrl = (props?: GetUrlProps) => {
    if (params === null) {
      return null;
    }
    let productId = params.akl ?? params.slug;
    if (!productId) {
      return null;
    }
    if (Array.isArray(productId)) {
      if (productId.length === 0) {
        return null;
      }
      [productId] = productId;
    }

    return localizeUrl(
      getCustomerRatingsAndReviewsPageUrl({
        productId,
        filterTags: Array.isArray(params.ftag) ? params.ftag : undefined,
        searchParams: searchParams ?? undefined,
        variationId: props?.variationId,
        page: props?.page,
      }),
      language,
    );
  };

  return { getUrl };
};
